"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockAlignment = void 0;
var BlockAlignment;
(function (BlockAlignment) {
    BlockAlignment["CENTER"] = "center";
    BlockAlignment["LEFT"] = "left";
})(BlockAlignment = exports.BlockAlignment || (exports.BlockAlignment = {}));
